<template>  
  <v-layout row wrap>
    <v-flex xs12 style="display:flex;flex-direction:column;">
      <v-card v-if="modifiedSingleWayPointConfig" class="pa-2" style="flex:1 1 auto;display:flex;flex-direction:column" >
        <v-card-title class="pb-0" style="flex:1 1 auto;flex-direction:column;align-items:start;position:relative;">         
          <span class="subheading mb-1" style="flex:0 0 auto">{{$t('Pilot.SingleWayPoint.Configuration')}}</span>
          <v-switch hide-details class="pb-2 sm-switch" v-model="config.enableSingleWayPoint" @change="saveConfig" :label="$t('Pilot.SingleWayPoint.EnableSingleWayPoint')" style="flex:0 0 auto" />
          <div class="flex-container" style="align-self: stretch;flex:1 0 auto;" >            
            <div class="flex-container scrollable-container" :class="{'disable':!config.enableSingleWayPoint}" >
              <v-card class="mb-3 mx-0" >                
                <v-card-title style="background-color:#fafafa;padding-right:40px;flex-direction:column;align-items:start">                  
                  <span class="subheading">{{$t('Pilot.SingleWayPoint.SingleWayPoint')}}</span>                                   
                  <v-layout row wrap mt-2>
                      <v-flex xs-12 class="flex-container">
                        <v-text-field type="number" v-model.number="config.heading_deadzone" :label="$t('Pilot.SingleWayPoint.HeadingDeadZone')" />
                        <!-- <v-text-field type="number" v-model.number="config.lat_target" :label="$t('Pilot.SingleWayPoint.LatTarget')" :suffix="config.lat_target?`(${$options.filters[this.coordFormatFilter]([1,config.lat_target],true)})`:''" />
                        <v-text-field type="number" v-model.number="config.lon_target" :label="$t('Pilot.SingleWayPoint.LonTarget')" :suffix="config.lon_target?`(${$options.filters[this.coordFormatFilter]([config.lon_target,1],false)})`:''"  /> -->
                        <v-layout row>
                          <lat-lng-field :format="coordFormatFilter" :label="$t('Pilot.SingleWayPoint.LatTarget')" v-model.number="config.lat_target" :isLat="true" class="mr-4" />        
                          <lat-lng-field :format="coordFormatFilter" :label="$t('Pilot.SingleWayPoint.LonTarget')" v-model.number="config.lon_target" :isLat="false" class="ml-4" />  
                        </v-layout>      
                      </v-flex>
                  </v-layout>                  
                </v-card-title>                
              </v-card>              
            </div>                  
          </div>                                             
        </v-card-title>
        <v-card-actions class="pr-3">
          <v-spacer />
          <!--<v-btn @click.prevent="resetConfig" small >{{$t('Pilot.SingleWayPoint.ResetConfig')}}<v-icon small right>mdi-backup-restore</v-icon></v-btn>-->          
          <v-btn @click.prevent="restoreConfig" :disabled="!btnActif" small>{{$t('Pilot.SingleWayPoint.RestoreConfig')}}<v-icon small right>mdi-replay</v-icon></v-btn> 
          <v-btn @click.prevent="saveConfig" :disabled="!btnActif" small color="primary">{{$t('Pilot.SingleWayPoint.ValidateConfig')}}<v-icon small right >mdi-content-save</v-icon></v-btn>           
        </v-card-actions>
      </v-card>
      <v-card v-else class="pa-2" style="flex:1 1 auto;display:flex;flex-direction:column" >
        <v-card-title class="pb-0" style="flex:1 1 auto;flex-direction:column;align-items:start;position:relative;">
          <span>{{$t('Pilot.SingleWayPoint.NoDataAvailable')}}</span>
        </v-card-title>
      </v-card>
    </v-flex> 
    <!-- Dialog de chargement... -->   
    <v-dialog
      v-model="loading"
      hide-overlay
      persistent
      width="300">
      <v-card color="primary" dark >
        <v-card-text>
          {{status}}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>   
  </v-layout>
</template>

<script lang="ts">
  import Vue from 'vue';
  //@ts-ignore
  import Component from 'vue-class-component';
import deepEqual from 'deep-equal';
import { Watch } from 'vue-property-decorator';
import { IrisConfigContainer } from '@/models/iris/IrisConfigContainer';
import { ISingleWayPointConfig } from '../../models/iris/singleWayPoint/ISingleWayPointConfig';


  @Component({
    name: 'MissionDetailSingleWayPoint',        
  })
  export default class MissionDetailSingleWayPoint extends Vue {  
    
    config = {
      enableSingleWayPoint : true,
      lat_target : 0,
      lon_target : 0,      
      heading_deadzone:0
    }        

    get currentDetailMission(){
      return this.$store.myGetters.currentDetailMission
    }

    get coordFormatFilter(){
      return this.$store.myGetters.coordFormatFilter
    }

    get btnActif() {
      const config = {}      
      this.loadConfig(config,this.originalSingleWayPointConfig)      
      return this.config.enableSingleWayPoint && !deepEqual(config,this.config) && !this.loading
    }

    get loading(){
      return this.$store.myGetters.singleWayPointLoading
    }

    get status(){
      return this.$store.myGetters.gliderStatus
    }

    created() {                                 
      if(this.mission.gliId != null) this.$store.myActions.GLIDER_IRIS_SINGLE_WAY_POINT_REQUEST(this.mission.gliId).then(() => {
         this.loadConfig(this.config,this.modifiedSingleWayPointConfig)          
      })                 
    }  

    mounted() {
      /*this.loadConfig(this.config,this.modifiedSingleWayPointConfig)*/
    }    
   
    get mission() {
        return this.currentDetailMission.mission
    }

    get originalSingleWayPointConfig() {
      return this.$store.myGetters.originalSingleWayPointConfigs[this.mission.gliId!]
    }         

    get modifiedSingleWayPointConfig() {
      return this.$store.myGetters.modifiedSingleWayPointConfigs[this.mission.gliId!]
    } 

    @Watch('mission')
    onMissionChanged(newValue: any) {                        
      if(newValue.gliId != null) this.$store.myActions.GLIDER_IRIS_SINGLE_WAY_POINT_REQUEST(newValue.gliId)      
    }
    
    @Watch('modifiedSingleWayPointConfig', { deep: true })
    onModifiedSingleWayPointChanged(newConfig: IrisConfigContainer<ISingleWayPointConfig>, oldConfig: IrisConfigContainer<ISingleWayPointConfig>) {            
      this.loadConfig(this.config,newConfig)      
    }

    @Watch('config', { deep: true })
    onConfigChanged(newConfig: any) {              
       this.validateConfig()
    }

    loadConfig(target:any, config: IrisConfigContainer<ISingleWayPointConfig>) {
      if(config) {
        target.enableSingleWayPoint = config.mod_settings.EnabledMOD['module-SingleWayPoint']
        target.lat_target = config.mod_settings.SingleWayPoint_target.lat_target
        target.lon_target = config.mod_settings.SingleWayPoint_target.lon_target
        target.heading_deadzone = config.mod_settings.SingleWayPoint_target.heading_deadzone        
      }
    }   
    validateConfig() {      
      this.$store.myActions.GLIDER_UPDATE_MODIFIED_SINGLE_WAY_POINT({
        itemId:this.mission.gliId!,
        newProperties: {
          mod_settings:{
            EnabledMOD:{              
              'module-SingleWayPoint': this.config.enableSingleWayPoint
            },
            SingleWayPoint_target:{
              lat_target: this.config.lat_target,
              lon_target: this.config.lon_target,
              heading_deadzone: this.config.heading_deadzone
            }            
          }
        } 
      })
    }

    saveConfig() {
      this.validateConfig()
      this.$store.myActions.GLIDER_IRIS_SINGLE_WAY_POINT_SAVE_REQUEST(this.mission.gliId!)
    }

    restoreConfig() {
      this.$store.myActions.GLIDER_CANCEL_MODIFIED_SINGLE_WAY_POINT(this.mission.gliId!)
    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>
  .subheading,.body-2{
    font-weight: bold;  
  }

  .btnup{
    position: absolute;
    top:-6px;
    right:-7px;    
  }
  .btnup:hover{
    position: absolute;
  }
  .btndown{
    position: absolute;
    bottom:-6px;
    right:-7px; 
  }
  .btndown:hover{
    position: absolute;
  }

  
  .flex-container{
    display:flex;
    flex-direction:column;
    position:relative;
  }

  .position{
    position: absolute;
    top:0px;
    right:0px;
    bottom:0px;
    width:31px;
    background-color: #eee;
    display:flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;    
  }

  .disable{
    overflow: hidden!important;
    position: relative;
  }

 
  .disable::before{
    position: absolute;
    content: '';
    left:0px;    
    right:0px;
    top: 0px;
    height:8000%;
    background-color: rgba(0,0,0,0.3);
    z-index: 1;
  }

</style>
